import React from 'react';

const faqs = [
  {
    question: 'How does it work?',
    answer: 'Simply contact me via phone, email or by filling out the form below. You can include a photo of the items you would like removed or I can come out and do a walkthrough. Then I will provide you with a free estimate.'
  },
  {
    question: 'What items do you accept for hauling?',
    answer: 'I accept most household items, furniture, appliances, yard waste, and more. However, I do not accept hazardous materials.'
  },
  {
    question: 'How much do your services cost?',
    answer: 'My pricing is based on the volume of items you need hauled away. Contact me for a free estimate.'
  },
  {
    question: 'Do you offer same-day service?',
    answer: 'Yes, I offer same-day service depending on availability. My current hours of operation are Monday through Friday from 10 AM to 4 PM and Saturday from 9AM to 5PM. Please contact me to schedule a pick-up.'
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'Currently I am only accepting cash or credit as a payment methods.'
  }
];

const FAQSection = () => {
  return (
    <section id="faq" className="pt-24 bg-white text-black">
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-4xl font-bold text-center mb-8" data-aos="fade-down">Frequently Asked Questions</h2>
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="p-4 bg-gray-100 rounded shadow" data-aos="fade-up" data-aos-delay={index * 100}>
              <h3 className="text-2xl font-semibold mb-2">{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
